<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-50"
           @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 pl-20 pt-20 pr-16 pb-12">
          <div class="text-app-color">
            <p class="text-22 font-black">Invite</p>
            <p v-if="options.length > 0" class="text-14 mt-3">Share the space with your team members.</p>
            <p v-else class="text-14 mt-3">No active team members.</p>

            <div v-if="options.length > 0" class="flex items-center my-20">
              <p class="text-14 font-semibold mr-7 flex-shrink-0">Choose member:</p>
              <SelectModule
                v-model="member"
                class="text-14 w-full max-w-270 rounded-4"
                item-class="truncate"
                :options="options"
              />
            </div>

            <div v-else class="text-14 my-20">
              You did not invite any team members yet.
              <span class="cursor-pointer text-link-color" @click="openTeamMemberModal">Please add new team members here</span>
            </div>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="Cancel"
              :has-hover="true"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              v-if="options.length > 0"
              text="Invite"
              class="bg-link-color rounded-4 px-35 py-12 text-white text-15"
              @click="invite"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, nextTick, ref } from 'vue'

import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import SelectModule from '@/components/shared/form-controls/SelectModule'
import { useStore } from 'vuex'
import { teamsService } from '@/services'

export default defineComponent({
  components: { ButtonModule, SelectModule },

  props: {
    book: Object
  },

  setup (props) {
    const { dispatch, commit } = useStore()

    const isModalOpen = ref(false)

    const member = ref(null)
    const options = ref([])

    function open () {
      const sharedWithIds = props.book.shareWith.map(i => i.id)

      dispatch('getMembers', { limit: 100 }).then((res) => {
        options.value = res.filter(i => !sharedWithIds.includes(i.id)).map(m => {
          return {
            id: m.id,
            name: `${m.firstName} ${m.lastName}`
          }
        })

        if (options.value.length > 0) {
          member.value = options.value[0]
        }

        preventBodyScroll(true)
        isModalOpen.value = true
      })
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
      commit('setMembers', [])
    }

    function openTeamMemberModal () {
      close()
      nextTick(() => {
        commit('changeActiveState', 'TeamMembers')
        commit('toggleSettingsModal', true)
        commit('toggleAside', false)
      })
    }

    function invite () {
      teamsService.addMemberToSpace({
        memberId: member.value.id,
        bookId: props.book.id
      }).then(() => {
        close()
        dispatch('getBooks')
        commit('setNotification', {
          isVisible: true,
          message: `<span class="font-bold">${member.value.name}</span> has been added to <span class="font-bold">${props.book.title}</span> space.`
        })
      })
    }

    return {
      // computed
      options,
      // refs
      isModalOpen,
      member,
      // function
      open,
      close,
      invite,
      openTeamMemberModal
    }
  }
})
</script>
